// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2AUuz","ranges":"BmiRanges_ranges__nWmj5"};